import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { it } from './locales/it'
import { en } from './locales/en'

const resources = {
  it: { translation: it },
  en: { translation: en },
}

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('language') || 'it',
  fallbackLng: 'it',
  interpolation: {
    escapeValue: false,
  },
})

export { i18n }
